export default __webpack_public_path__ + "static/simple-bubble-8dec1e80af362a7436ad092680bbcbe1.png";